import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  REFUND_LOGS_REPORT,
  REFUND_LOGS_REPORT_COUNT,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  refundLogsData: [],
  status: false,
  error: "",

  countLoading: false,
  countData: 0,
};

let abortRefundLogs = null;
let abortRefundLogsCount = null;

// Fetch Online Order Refund Logs (USAePay)
export const fetchRefundLogsData = createAsyncThunk(
  "RefundLogsReport/fetchRefundLogsData",
  async (data, { rejectWithValue }) => {
    try {
      if (abortRefundLogs) {
        abortRefundLogs.abort();
      }

      abortRefundLogs = new AbortController();
      const signal = abortRefundLogs.signal;

      const { token, ...dataNew } = data;
      const response = await axios.post(
        BASE_URL + REFUND_LOGS_REPORT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );

      if (response?.data?.status === true) {
        const arr = response?.data?.result || [];
        const status = response?.data?.status;
        return { arr, status };
      }

      if (
        response?.data?.status === false &&
        response?.data?.msg === "No Data Found."
      ) {
        const arr = [];
        const status = false;
        return { arr, status };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchRefundLogsCount = createAsyncThunk(
  "RefundLogsReport/fetchRefundLogsCount",
  async (payload, { rejectWithValue }) => {
    const { token, ...dataNew } = payload;
    try {
      if (abortRefundLogsCount) {
        abortRefundLogsCount.abort();
      }

      abortRefundLogsCount = new AbortController();
      const signal = abortRefundLogsCount.signal;

      const response = await axios.post(
        BASE_URL + REFUND_LOGS_REPORT_COUNT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );

      if (response?.data?.status) {
        return response?.data?.total_count ?? 0;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const RefundLogsReportSlice = createSlice({
  name: "RefundLogsReport",
  initialState,
  reducers: {
    resetRefundLogsState: (state) => {
      state.refundLogsData = [];
      state.status = false;
      state.error = "";
      state.countData = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchRefundLogsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRefundLogsData.fulfilled, (state, action) => {
      state.loading = false;
      state.refundLogsData = action.payload.arr;
      state.status = action.payload.status;
      state.error = "";
    });
    builder.addCase(fetchRefundLogsData.rejected, (state, action) => {
      state.loading = false;
      state.refundLogsData = [];
      state.error = action.payload?.message || action.error?.message || "";
    });

    builder.addCase(fetchRefundLogsCount.pending, (state) => {
      state.countLoading = true;
    });
    builder.addCase(fetchRefundLogsCount.fulfilled, (state, action) => {
      state.countLoading = false;
      state.countData = action.payload || 0;
    });
    builder.addCase(fetchRefundLogsCount.rejected, (state, action) => {
      state.countLoading = false;
      state.countData = 0;
    });
  },
});

export const { resetRefundLogsState } = RefundLogsReportSlice.actions;
export default RefundLogsReportSlice.reducer;

